import type { StackletHistoryEvent } from '@/entities/stacklet';
import type { RequestMeta, ResponseMeta } from '@/shared/api';
import request from '@/shared/api/request';

export const getStackletHistory = (
  id: number,
  params?: RequestMeta,
): Promise<{ history: StackletHistoryEvent[]; meta: ResponseMeta }> =>
  request({
    url: `/stacklets/${id}/history/`,
    params,
  });
